// โหลดรูปให้เสร็จก่อนสั่งพิมพ์
//
// ทำไมต้องมีไฟล์นี้: window.print() จับภาพหน้า ณ วินาทีนั้นเลย รูปไหนยังโหลดไม่เสร็จ
// จะพิมพ์ออกมาเป็นช่องว่าง — และพลาดแบบเงียบ ๆ (ตอนทดสอบแคชอุ่นอยู่เลยดูปกติ
// แต่คนที่พิมพ์ครั้งแรกจะได้กระดาษที่รูปหาย)
//
// ข้อควรรู้ที่วัดมาแล้ว:
//  · ห้ามใช้ img.decode() เป็นตัวรอ — ถ้าแท็บไม่ได้อยู่หน้าจอ decode() ค้างไม่ยอม
//    resolve/reject เลย (แม้รูปโหลดเสร็จแล้ว) ปุ่มพิมพ์จะกลายเป็นกดแล้วไม่เกิดอะไร
//  · ใช้ load/error + img.complete พอ ใช้ได้ทุกกรณีรวมถึงตอนอยู่ใน display:none
//  · error ต้อง resolve (ห้าม reject) — รูปเสียรูปเดียวต้องไม่ทำให้พิมพ์ไม่ออก

/** โหลดรูปทุกอันให้จบก่อน (หรือหมดเวลา) — คืน Set ของ URL ที่โหลดสำเร็จ */
export function preloadImages(urls, timeoutMs = 6000) {
  const list = [...new Set((urls || []).filter(Boolean))];
  const ok = new Set();
  if (!list.length) return Promise.resolve(ok);

  const one = url => new Promise(done => {
    const img = new Image();
    img.onload = () => { ok.add(url); done(); };
    img.onerror = () => done();          // รูปตายก็ข้าม ไม่บล็อกการพิมพ์
    img.src = url;
    if (img.complete && img.naturalWidth) { ok.add(url); done(); }   // แคชอยู่แล้ว
  });

  return Promise.race([
    Promise.all(list.map(one)).then(() => ok),
    new Promise(done => setTimeout(() => done(ok), timeoutMs)),
  ]);
}

/**
 * รอให้เบราว์เซอร์วาดจริง 1 รอบก่อน (สองชั้นกันเฟรมแรกที่ยัง layout ไม่เสร็จ)
 * ⚠️ requestAnimationFrame ไม่ยิงเลยถ้าแท็บไม่ได้อยู่หน้าจอ — ถ้ารอเฉย ๆ ปุ่มพิมพ์
 * จะกดแล้วไม่เกิดอะไรขึ้น (เจอจริงตอนเทสต์) เลยต้องมีเวลาสูงสุดกำกับไว้เสมอ
 */
export const afterPaint = (maxWaitMs = 400) => new Promise(res => {
  let done = false;
  const finish = () => { if (!done) { done = true; res(); } };
  requestAnimationFrame(() => requestAnimationFrame(finish));
  setTimeout(finish, maxWaitMs);
});
